// extracted by mini-css-extract-plugin
module.exports = {"lbfy1yq":"lbfy1yq"};